import { Accordion, AccordionDetails, AccordionSummary, Text } from 'shell/components';

const AccordionDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>Accordion</Text>
            <Accordion>
                <AccordionSummary>
                    <Text>Accordion Summary</Text>
                </AccordionSummary>
                <AccordionDetails>
                    <Text>Accordion Details</Text>
                </AccordionDetails>
            </Accordion>
        </>
    );
};

export default AccordionDemo;
